module.exports = __webpack_public_path__ + "static/media/demo11.104746d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/demo11.mp4
// module id = r4tf
// module chunks = 1